import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import InputLabel from "@mui/material/InputLabel";
import Box from "@mui/material/Box";
import { Autocomplete, Button } from "@mui/material";
import { Typography } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import FormControlLabel from "@mui/material/FormControlLabel";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { addIncomes, fetchIncomeAndExpensesById, fetchVehicle, updateIncome } from "../../store/slices/thunk";
import { toast, ToastContainer } from "react-toastify";
import Spinner from "react-bootstrap/esm/Spinner";

const Addincome = () => {
    const [addIncome, setaddIncome] = useState({
      vehicle: {
        vehicleId: "",
        vehicleName: "",
      },
      type: "",
      date: 0,
      description: "",
      amount: 0,
      _id: "",
    });
    const { id } = useParams<any>();
  const navigate = useNavigate();
    const [isEdit, setIsEdit] = useState(false);
    const dispatch: any = useDispatch();
    const [getAllVehicle, setAllVehicle] = useState([]);
    const [loading, setLoading] = useState(false);



    useEffect(() => {
        const getVehicle = async () => {
          const response = await dispatch(fetchVehicle(1, 9999, ""));
          if (response !== null && response.data.data.length > 0 && response.isSuccess) {
            setAllVehicle(response.data.data);
          } else {
            setAllVehicle([]);
          }
          console.log(getAllVehicle);
        };
    
        getVehicle();
      }, [dispatch]);
    
 useEffect(() => {
    const fetchData = async () => {
      if (id) {
        setIsEdit(true);
        const response: any = await dispatch(fetchIncomeAndExpensesById(id));
        const {
          vehicle,
          type,
          date,
          description,
          amount,
          _id,
        } = response.data;

        setaddIncome({
          vehicle: {
            vehicleId: vehicle?.vehicleId || "",
            vehicleName: vehicle?.vehicleName || "",
          },
          type: type || "",
          date: date || 0,
          description:description || "",
          amount: amount || 0,
          _id: _id || "",
        });

        console.log("Fetched Maintenance:", response.data);
      } else {
        setIsEdit(false);
        setaddIncome({
          vehicle: {
            vehicleId: "",
            vehicleName: "",
          },
          type: "",
          date: 0,
          description: "",
          amount: 0,
          _id: "",
        });
      }
    };

    fetchData();
  }, [id, navigate, dispatch]);



   const handleSubmit = async (e: any) => {
        e.preventDefault();
        console.log("Sending:", addIncome);
        setLoading(true);

        try {
          const {
            vehicle,
            type,
            date,
            description,
            amount,
            _id,
          } = addIncome;
          if (
            vehicle.vehicleId === "" ||
            vehicle.vehicleName === "" ||
            type === "" ||
            date === 0 ||
            description === "" ||
            amount === 0           ) {
            toast.error("Fill all required fields!");
            return;
          }
    
          if (isEdit) {
            const res: any = await dispatch(updateIncome(addIncome));
            if (res.data && res.isSuccess) {
              console.log("Success:", res);
              toast.success("Income Updated!");
              navigate("/income-and-expenses-list");
            } else {
              toast.error("Income Not Updated!");
            }
          } else {
            const res: any = await dispatch(addIncomes(addIncome));
            if (res.data && res.isSuccess) {
              console.log("Success:", res);
              toast.success("Income Added!");
              navigate("/income-and-expenses-list");
            } else {
              toast.error("Income Not Added!");
            }
          }
        } catch (error) {
          console.error("Error:", error);
          toast.error("Something went wrong!");
        } finally {
          setLoading(false);
        }
      };

    const handleChangeForVehicle = (e: any) => {
      const { value } = e.target;
      const selectedVehicle: any = getAllVehicle.find(
        (vehicle: any) => vehicle._id === value
      );
  
      if (selectedVehicle) {
        setaddIncome({
          ...addIncome,
          vehicle: {
            vehicleId: selectedVehicle._id,
            vehicleName: selectedVehicle.vehicleName,
          },
        });
      }
    };
      const navigateToIcomeList = () => {
    navigate("/income-and-expenses-list");
  };
    const handleChange = (e:any) => {
      const { name, value } = e.target;
      setaddIncome((prevData) => ({
        ...prevData,
        [name]: value
      }));
    };
  return (
    <>
      <div className="boDy">
        <ToastContainer/>
        <div className="head d-flex justify-content-lg-between justify-content-start flex-column flex-lg-row flex-wrap">
          <div className="d-flex flex-column">
            <h2 className="fw-bold fs-4" style={{ color: "#1F2937" }}>{isEdit ? "Edit Record" : "Add New Record"}</h2>
            <p style={{ color: "#4B5563" }}>Track income and expense transactions</p>
          </div>
          <button
            type="button"
            onClick={navigateToIcomeList}
            className="btn rounded-2"
            style={{ backgroundColor: "transparent",width:"fit-content" }}
          >
            <KeyboardBackspaceIcon />
            <span style={{marginLeft:"10px"}}>Back To List</span>
          </button>
        </div>
        <div className="box">
          <div className="container">
            <div className="row">
              <div className="col-md-6 mt-3">
                <h6 className="d-block mb-2"
  style={{
    fontSize: "0.875rem",
    fontWeight: 700,
    color: "#374151",
  }}>Vehicle*</h6>
                <Autocomplete
  options={getAllVehicle}
  getOptionLabel={(option: any) => option.vehicleName || ""}
  value={
    getAllVehicle.find(
      (vehicle: any) => vehicle._id === addIncome.vehicle.vehicleId
    ) || null
  }
  onChange={(event, newValue) => {
    if (newValue) {
      handleChangeForVehicle({
        target: { value: newValue._id },
      });
    }
  }}
  renderInput={(params) => (
    <TextField {...params} label="Select or Search Vehicle" />
  )}
  filterOptions={(options, state) => {
    // Search value entered?
    const inputValue = state.inputValue?.toLowerCase() || "";

    // Search matching logic
    const filtered = options.filter((option: any) =>
      option.vehicleName?.toLowerCase().includes(inputValue)
    );

    // Return top 10 matching
    return filtered.slice(0, 10);
  }}
    componentsProps={{
    paper: {
      sx: {
        backgroundColor: "#fff",
        color: "#333", // text color
        "& .MuiAutocomplete-option": {
          color: "#212121", // option text color (dark gray)
          "&:hover": {
            backgroundColor: "#f0f0f0", // light hover
          },
          "&[aria-selected='true']": {
            backgroundColor: "#e0e0e0", // selected option
            color: "#000",
          },
        },
      },
    },
  }}
  sx={{ minWidth: 120 }}
/>
              </div>
              <div className="col-md-6 mt-3">
                <h6 className="d-block mb-2"
  style={{
    fontSize: "0.875rem",
    fontWeight: 700,
    color: "#374151",
  }}>Type*</h6>
                <Box sx={{ minWidth: 120 }}>
                  <FormControl fullWidth>
                    <Select
                                           labelId="vehicle-label"
                                           name="type"
                                           value={addIncome.type}
                                           onChange={handleChange}
                    >
                      <MenuItem value="Income" sx={{ color: "#000" }}>Income</MenuItem>
                      <MenuItem value="Expense" sx={{ color: "#000" }}>Expense</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </div>
              <div className="col-md-6 mt-3">
                <h6 className="d-block mb-2"
  style={{
    fontSize: "0.875rem",
    fontWeight: 700,
    color: "#374151",
  }}> Date*</h6>
                  <TextField
                    id="outlined-basic"
                    placeholder="Date"
                    variant="outlined"
                    type="date"
                    value={
              addIncome?.date
                    ? new Date(addIncome?.date).toISOString().split("T")[0]
                    : ""
                }
                  onChange={(e) =>
                    setaddIncome({
                      ...addIncome,
                      date: new Date(e.target.value).getTime(),
                    })
                  }
                    fullWidth sx={{
                    '& .MuiInputBase-input': {
                    padding: '10px',
                    },
                    }}
                    />
              </div>
               <div className="col-md-6 mt-3">
                <h6 className="d-block mb-2"
  style={{
    fontSize: "0.875rem",
    fontWeight: 700,
    color: "#374151",
  }}>Amount*</h6>
                <TextField
                    id="outlined-basic"
                    placeholder="Amount"

                    value={addIncome.amount}
                    onChange={handleChange}
                    name="amount"
                    type="number"
                    variant="outlined"
                    fullWidth sx={{
                    '& .MuiInputBase-input': {
                    padding: '10px',
                    },
                    }}
                    />
              </div>
              <div className="col-md-12 mt-3">
                <h6 className="d-block mb-2"
  style={{
    fontSize: "0.875rem",
    fontWeight: 700,
    color: "#374151",
  }}>Description</h6>
          <textarea
  id="outlined-basic"
  placeholder="Description"
  name="description"
  value={addIncome.description}
  onChange={handleChange}
  style={{
    width: "100%",
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    fontSize: "14px",
    minHeight: "80px",
  }}
></textarea>

              </div>
            </div>
          </div>
          {/* <div className="container mt-3">
            <div className="row">
              <div className="col-md-3">
                <h6>Amount*</h6>
                <TextField
                    id="outlined-basic"
                    placeholder="Amount"

                    value={addIncome.amount}
                    onChange={handleChange}
                    name="amount"
                    type="number"
                    variant="outlined"
                    fullWidth sx={{
                    '& .MuiInputBase-input': {
                    padding: '10px',
                    },
                    }}
                    />
              </div>
            </div>
          </div> */}

          <div  className="mt-4 aDDDd">
            <Button  onClick={handleSubmit} disabled={loading} style={{ textTransform: "none",fontWeight:"600",width:"auto" }}>
                    {loading ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                        {isEdit ? "Edit..." : "Add..."}
                      </>
                    ) : (
                      isEdit ? "Edit Income /Expense " : "Add Income /Expense"
                    )}
                  </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Addincome;
